import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Next = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Next' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='7 2 17 12 7 22' />
  </StyledIcon>
);
